import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="h-screen flex flex-col items-center justify-center text-center p-4">
            <h1 className="text-7xl font-bold">404</h1>
            <Link to="/" className="underline text-primary">
                Go back to the homepage
            </Link>
        </div>
    );
}